const matcher = /(\d+)([+-/*//x:])(\d+)/;

const sum = (a, b) => a + b;
const subtract = (a, b) => a - b;
const multiply = (a, b) => a * b;
const divide = (a, b) => a / b;

const operations = {
  '+': sum,
  '-': subtract,
  '*': multiply,
  x: multiply,
  '/': divide,
  ':': divide
};

const parser = calculation => {
  const [, op1, operator, op2] = matcher.exec(calculation);
  const operand1 = Number(op1);
  const operand2 = Number(op2);
  return operations[operator](operand1, operand2);
};

export default parser;
